<template>
  <div class="d-flex flex-column align-center justify-center">
    <div v-if="status == 'pending'" class="d-flex flex-column align-center justify-center">
      <div>
        <div class="text-h6 text-uppercase">Ouverture des <span
            v-if="mainStore.module.has_preinscription">pré</span>inscriptions dans</div>
      </div>
      <div class="d-flex flex-start sm-gap">
        <div v-if="countdown.months && countdown.months > 0"
          class="d-flex flex-column align-center px-2 py-1 rounded spo-card bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.months }}</div>
          <div>mois</div>
        </div>
        <div class="d-flex flex-column align-center px-2 py-1 rounded spo-card bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.days }}</div>
          <div>jour<span v-if="countdown.days > 1">s</span></div>
        </div>
        <div class="d-flex flex-column align-center px-2 py-1 rounded spo-card bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.hours }}</div>
          <div>heure<span v-if="countdown.hours > 1">s</span></div>
        </div>
        <div class="d-flex flex-column align-center px-2 py-1 rounded spo-card bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.minutes }}</div>
          <div class="">min<span v-if="countdown.minutes > 1">s</span></div>
        </div>
        <div class="d-flex flex-column align-center px-2 py-1 rounded spo-card bordered" elevation="0">
          <div class="font-weight-bold text-dark-red" style="font-size: 1.3rem">{{ countdown.seconds }}</div>
          <div>sec<span v-if="countdown.seconds > 1">s</span></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex flex-column align-center justify-center">
        <div class="text-h6 text-uppercase">Ouverture en cours, cette page va automatiquement s'actualiser dans {{
          countdown.seconds }} secondes</div>
        <!-- spinner -->
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>

  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';

export default {
  props: ["date", "heure"],
  data() {
    return {
      defer: Math.floor(Math.random() * 15),
      status: "pending",
      countdown: {
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      interval: null,
      targetDate: this.$moment(this.date + " " + this.heure),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    // Calculate the countdown
    async calculateCountdown() {

      const now = this.$moment();
      let target = this.$moment(this.targetDate);
      // add random seconds to defer the reload, 0 to 20 seconds
      if (this.status == 'done') {
        target.add(this.defer, 'seconds');
      }
      const duration = this.$moment.duration(target.diff(now));

      if (parseInt(duration.seconds()) < 0) {
        if (this.status == 'done') {

          const base_module = this.$route.params.base_module;

          const heure_ouverture = this.mainStore.module.heure_debut_inscription;
          await this.mainStore.initializeApp(base_module, heure_ouverture);
          clearInterval(this.interval);
          this.$emit('onReload');
          // Redirection vers la même route pour déclencher le rechargement
          this.$router.push(this.$route.path);
        }
        else {

          this.countdown.seconds = 0;
          this.status = "done";
        }



      }
      this.countdown.months = this.formatValue(duration.months());
      this.countdown.days = this.formatValue(duration.days());
      this.countdown.hours = this.formatValue(duration.hours());
      this.countdown.minutes = this.formatValue(duration.minutes());
      this.countdown.seconds = this.formatValue(duration.seconds());
    },
    formatValue(value) {
      if (value < 0) {
        return "00";
      }
      return value < 10 ? "0" + value : value;
    },
  },
  mounted() {
    this.calculateCountdown();
    // Update the countdown every second
    this.interval = setInterval(() => {
      this.calculateCountdown();
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped></style>